import { render, staticRenderFns } from "./PolicyValues.vue?vue&type=template&id=2df99ac5&"
import script from "./PolicyValues.vue?vue&type=script&lang=ts&"
export * from "./PolicyValues.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports